export default "__VITE_ASSET__068ee814__"